<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>营销</el-breadcrumb-item>
            <el-breadcrumb-item>分销</el-breadcrumb-item>
            <el-breadcrumb-item>提现管理</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="dis-flex">
            <div class="second-swaper">
                <second></second>
            </div>
            <div class="flex-box" style="overflow-x: hidden">
                <Card :bordered="false" dis-hover class="ivu-mt">
                    <Form
                            ref="tableFrom"
                            :model="tableFrom"
                            :label-width="labelWidth"
                            :label-position="labelPosition"
                            @submit.native.prevent>
                        <Row type="flex" :gutter="24">
                            <Col v-bind="grid">
                                <FormItem label="商品搜索：" label-for="store_name">
                                    <Input
                                            search
                                            enter-button
                                            placeholder="请输入昵称/姓名/手机号"
                                            v-model="tableFrom.search"
                                            @on-search="userSearchs"/>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row type="flex" class="mb20">
                            <Col v-bind="grid">
                            </Col>
                        </Row>
                    </Form>
                    <Table
                            class="mt25"
                            :columns="columns1"
                            :data="tableList"
                            :loading="loading"
                            ref="selection"
                            highlight-row
                            no-userFrom-text="暂无数据"
                            no-filtered-userFrom-text="暂无筛选结果">
                        <template slot-scope="{ row, index }" slot="avatars">
                            <viewer>
                                <div class="tabBox_img">
                                    <img v-lazy="row.avatar" />
                                </div>
                            </viewer>
                        </template>
                        <template slot-scope="{ row, index }" slot="nickname">
                            <div class="acea-row">
                                <Icon
                                        type="md-male"
                                        v-show="row.gender === 1"
                                        color="#2db7f5"
                                        size="15"
                                        class="mr5"/>
                                <Icon
                                        type="md-female"
                                        v-show="row.gender === 2"
                                        color="#ed4014"
                                        size="15"
                                        class="mr5"/>
                                <div v-text="row.nick_name"></div>
                            </div>
                        </template>
                        <template slot-scope="{ row, index }" slot="real_name">
                            <div>{{row.real_name}}</div>
                            <div>{{row.mobile}}</div>
                        </template>
                        <template slot-scope="{ row, index }" slot="pay_type">
                            <div v-if="row.pay_type == 10">积分提现</div>
                            <div v-if="row.pay_type == 20">支付宝</div>
                            <div v-if="row.pay_type == 30">银行卡</div>
                        </template>
                        <template slot-scope="{ row, index }" slot="pay_info">
                            <div v-if="row.pay_type == 10">-</div>
                            <div v-if="row.pay_type == 20">
                                <div>姓名：{{row.alipay_name}}</div>
                                <div>支付宝账号：{{row.alipay_account}}</div>
                            </div>
                            <div v-if="row.pay_type == 30">
                                <div>持卡人：{{row.bank_account}}</div>
                                <div>开户行名称：{{row.bank_name}}</div>
                                <div>卡号：{{row.bank_card}}</div>
                            </div>
                        </template>
                        <template slot-scope="{ row, index }" slot="apply_status">
                            <Tag color="blue" v-if="row.apply_status == 10">待审核</Tag>
                            <Tag color="green" v-if="row.apply_status == 20">审核通过</Tag>
                            <Tag color="error" v-if="row.apply_status == 30">驳回</Tag>
                            <Tag color="green" v-if="row.apply_status == 40">已打款</Tag>
                            <div v-if="row.apply_status == 30">驳回原因：{{row.reject_reason}}</div>
                        </template>
                        <template slot-scope="{ row, index }" slot="audit_time">
                            <div v-if="row.audit_time > 0">{{row.audit_time | formatDate}}</div>
                        </template>
                        <template slot-scope="{ row, index }" slot="action">
                            <a @click="audit(row)" v-if="row.apply_status == 10">审核</a>
                            <a @click="pay(row)" v-if="row.apply_status == 20 && row.pay_type != 10">确认打款</a>
                            <a @click="wechat_pay(row)" v-if="row.apply_status == 20 && row.pay_type == 10">积分提现</a>
                        </template>
                    </Table>
                    <div class="acea-row row-right page">
                        <Page
                                :total="total"
                                :current="tableFrom.page"
                                show-elevator
                                show-total
                                @on-change="pageChange"
                                :page-size="tableFrom.limit"/>
                    </div>
                </Card>
            </div>
        </div>
        <audit-from
                ref="audit"
                @confirmFormData="confirmFormData"></audit-from>
    </div>
</template>

<script>
    import auditFrom from "./handle/audit";
    import second from "../second.vue";
    export default {
        name: "index",
        components: { second, auditFrom },
        data() {
            return {
                isLoad: false,
                headeNum: [
                    { type: "0", name: "全部" },
                    { type: "10", name: "待审核" },
                    { type: "20", name: "审核通过" },
                    { type: "40", name: "已打款" },
                    { type: "30", name: "驳回" },
                ],
                loading: false,
                columns1: [
                    {
                        title: "ID",
                        key: "user_id",
                        width: 80,
                    },
                    {
                        title: "头像",
                        slot: "avatars",
                        width: 60,
                    },
                    {
                        title: "昵称",
                        slot: "nickname",
                        minWidth: 150,
                    },
                    {
                        title: "姓名/手机号",
                        slot: "real_name",
                        minWidth: 100,
                    },
                    {
                        title: "提现金额(元)",
                        key: "money",
                        minWidth: 100,
                    },
                    {
                        title: "提现方式",
                        slot: "pay_type",
                        minWidth: 100,
                    },
                    {
                        title: "提现信息",
                        slot: "pay_info",
                        minWidth: 150,
                    },
                    {
                        title: "审核状态",
                        slot: "apply_status",
                        minWidth: 150,
                    },
                    {
                        title: "申请时间",
                        key: "create_time",
                        minWidth: 150,
                    },
                    {
                        title: "审核时间",
                        slot: "audit_time",
                        minWidth: 150,
                    },
                    {
                        title: "操作",
                        slot: "action",
                        fixed: "right",
                        minWidth: 130,
                    },
                ],
                tableList: [],
                grid: {
                    xl: 7,
                    lg: 10,
                    md: 12,
                    sm: 24,
                    xs: 24,
                },
                tableFrom: {
                    type: "",
                    search: "",
                    export: 0,
                    page: 1,
                    limit: 15,
                },
                tableFrom2: {
                    status: "",
                    store_name: "",
                    export: 1,
                },
                total: 0,
            };
        },
        computed: {
            labelWidth() {
                return 80;
            },
            labelPosition() {
                return "left";
            },
        },
        created() {
            this.getList();
        },
        methods: {
            // 数据导出；
            async exports() {
                let [th, filekey, data, fileName] = [[], [], [], ""];
                //   let fileName = "";
                let excelData = JSON.parse(JSON.stringify(this.tableFrom));
                excelData.page = 1;
                for (let i = 0; i < excelData.page + 1; i++) {
                    let lebData = await this.getExcelData(excelData);
                    if (!fileName) fileName = lebData.filename;
                    if (!filekey.length) {
                        filekey = lebData.filekey;
                    }
                    if (!th.length) th = lebData.header;
                    if (lebData.export.length) {
                        data = data.concat(lebData.export);
                        excelData.page++;
                    } else {
                        exportExcel(th, filekey, fileName, data);
                        return;
                    }
                }
            },
            getExcelData(excelData) {
                return new Promise((resolve, reject) => {
                    stroeBargainApi(excelData).then((res) => {
                        return resolve(res.data);
                    });
                });
            },
            onClickTab(type) {
                this.tableFrom.page = 1;
                this.tableFrom.type = type;
                this.getList();
            },

            // 列表
            getList() {
                this.loading = true;
                this.axios.post('/store/app.dealer.withdraw/list',this.tableFrom)
                    .then(async (res) => {
                        let data = res.data;
                        this.tableList = data.list.data;
                        this.total = data.list.total;
                        this.loading = false;
                    })
                    .catch((res) => {
                        this.loading = false;
                        this.$Message.error(res.msg);
                    });
            },
            pageChange(index) {
                this.tableFrom.page = index;
                this.getList();
            },
            // 表格搜索
            userSearchs() {
                this.tableFrom.page = 1;
                this.getList();
            },
            audit(item) {
                this.id = item.id
                this.$refs.audit.modals = true;
            },
            pay(item) {
                this.$Modal.confirm({
                    title: '提示',
                    content: '<p>确定已打款吗？</p>',
                    loading: true,
                    onOk: () => {
                        this.axios.post('/store/app.dealer.withdraw/money', {
                            id: item.id
                        })
                        .then(async (res) => {
                            if (res.code == 1) {
                                this.$Modal.remove();
                                this.getList()
                            } else {
                                this.$Message.error(res.msg);
                                this.$Modal.remove();
                            }
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                    }
                })
            },
            wechat_pay(item) {
                this.$Modal.confirm({
                    title: '提示',
                    content: '<p>确定提现到积分吗？</p>',
                    loading: true,
                    onOk: () => {
                        this.axios.post('/store/app.dealer.withdraw/wechat_pay', {
                            id: item.id
                        })
                            .then(async (res) => {
                                if (res.code == 1) {
                                    this.$Modal.remove();
                                    this.getList()
                                } else {
                                    this.$Message.error(res.msg);
                                    this.$Modal.remove();
                                }
                            })
                            .catch((res) => {
                                this.$Message.error(res.msg);
                            });
                    }
                })
            },
            confirmFormData: function (formData) {
                this.axios.post('/store/app.dealer.withdraw/audit', Object.assign({
                    withdraw: formData
                }, {
                    id: this.id
                }))
                .then(async (res) => {
                    if (res.code == 1) {
                        this.$refs.audit.modals = false;
                        this.$Message.success(res.msg);
                        this.ids = []
                        this.getList();
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
            },
        },
    }
</script>

<style scoped>

</style>
